(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/fractiongames/assets/react/components/game-card/countdown.js') >= 0) return;  svs.modules.push('/components/numbergames/fractiongames/assets/react/components/game-card/countdown.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useContext = _React.useContext,
  useEffect = _React.useEffect,
  useState = _React.useState;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector,
  useDispatch = _ReactRedux.useDispatch;
const clientNow = svs.numbergames.draws.drawsApi.clientNow;
const ContainerContext = svs.numbergames.fractiongames.contexts.ContainerContext;
const actions = svs.numbergames.fractiongames.redux.slices.containers.actions;
let countdown;
const subscribers = {};
function subscribeToCountdown(_ref) {
  let id = _ref.id,
    cb = _ref.cb;
  subscribers[id] = cb;
  countdown !== null && countdown !== void 0 ? countdown : countdown = setInterval(() => Object.values(subscribers).forEach(cb => cb()), 1000);
  return () => {
    delete subscribers[id];
    if (!Object.keys(subscribers).length) {
      clearInterval(countdown);
      countdown = null;
    }
  };
}
function calcDisplayTimeLeft(buyinCloseTime) {
  if (!buyinCloseTime) return {
    minutesLeft: 0,
    secondsLeft: 0
  };
  const MS_IN_MINUTE = 60 * 1000;
  const millisecondsDiff = dateFns.differenceInMilliseconds(new Date(buyinCloseTime), clientNow());
  return {
    minutesLeft: millisecondsDiff > MS_IN_MINUTE ? Math.ceil(millisecondsDiff / MS_IN_MINUTE) : 0,
    secondsLeft: millisecondsDiff <= MS_IN_MINUTE && millisecondsDiff > 0 ? Math.ceil(millisecondsDiff / 1000) : 0
  };
}
function formatCountdownText(count, text) {
  count = count > 9 ? count : " ".concat(count); 
  text = count > 1 ? "".concat(text, "er") : "".concat(text, "  "); 
  return "".concat(count, " ").concat(text);
}
const Countdown = () => {
  const dispatch = useDispatch();
  const _useContext = useContext(ContainerContext),
    selectors = _useContext.selectors;
  const containerId = useSelector(selectors.selectContainerId);
  const buyinCloseTime = useSelector(selectors.selectBuyinCloseTime);
  const _useState = useState(calcDisplayTimeLeft(buyinCloseTime).secondsLeft),
    _useState2 = _slicedToArray(_useState, 2),
    secondsLeft = _useState2[0],
    setSecondsLeft = _useState2[1];
  const _useState3 = useState(calcDisplayTimeLeft(buyinCloseTime).minutesLeft),
    _useState4 = _slicedToArray(_useState3, 2),
    minutesLeft = _useState4[0],
    setMinutesLeft = _useState4[1];
  useEffect(() => {
    const unsubscribe = subscribeToCountdown({
      id: containerId,
      cb: () => {
        const _calcDisplayTimeLeft = calcDisplayTimeLeft(buyinCloseTime),
          minutesLeft = _calcDisplayTimeLeft.minutesLeft,
          secondsLeft = _calcDisplayTimeLeft.secondsLeft;
        setMinutesLeft(minutesLeft);
        setSecondsLeft(secondsLeft);
        if (!minutesLeft && !secondsLeft) {
          dispatch(actions.gameBuyinClosed(containerId));
        }
      }
    });
    return () => unsubscribe();
  }, [buyinCloseTime, containerId, dispatch]);
  return React.createElement("span", {
    className: "f-numeric"
  }, "K\xF6pstopp om: ", minutesLeft ? formatCountdownText(minutesLeft, 'minut') : formatCountdownText(secondsLeft, 'sekund'));
};
svs.numbergames.fractiongames.components.gamecard.Countdown = Countdown;

 })(window);